import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, User, UserService } from '../../shared';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';


@Component({
  selector: 'app-assement',
  templateUrl: './helpdesk.component.html',
  styleUrls: ['./helpdesk.component.css']
})
export class HelpdeskpageComponent implements OnInit {
  success: MatDialogRef<SucesstempComponent>;
  patientid: any;
  params: any;
  ques: any;
  app: any;
  public myobj: any = {};
  public carepath: any = {};
  public apiurl: any = environment.api_url;
  public obj: any = {};
  public myobj1: any = {};
  resabs: any;
  resab: any;
  modalRef: any;
  CurrentUser: User;
  surgeoninfo: any = [];
  public patid: any;
  constructor(
    private toast: ToastrService,
    private activeroute: ActivatedRoute,
    private routers: Router,
    private patientservice: PatientService,
    private userservice: UserService,
    private dialog: MatDialog,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {

    this.activeroute.params.subscribe(params => {
      this.params = params

      //////console.log(this.params.id)
    });

    this.userservice.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        // this.CurrentUser.status = false
        ////console.log(this.CurrentUser.item, "CurrentUser");
      }

    );
    this.CurrentUser.operationStatus = 'material'
    this.CurrentUser.operationMessage = ''





  }

  understand() {
    this.userservice
      .postuserinfoid(1, this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          this.surgeoninfo = data[0].patientStageWorkflow[0].patientId
          ////console.log(this.surgeoninfo)
          this.userservice
            .postsupport(this.surgeoninfo)
            .subscribe(
              data => {

                ////console.log(data)
                if (data) {
                  this.userservice.logAudit("updateSupport", 0).subscribe(data => { })
                  // this.success = this.dialog.open(SucesstempComponent, { disableClose: true });
                  // this.success.componentInstance.assessment = 'activity';
                  // this.success.componentInstance.message = 'completed';
                  this.routers.navigate([`/patient/dashboard`])

                }
              }
            );
        }

      );
  }






  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }


  submitabout() {
    this.resabs = " ";
    //////console.log(this.ques);
    this.myobj.profileQuestions = "";
    this.myobj.profileQuestions = this.ques;
    //////console.log("ques:", this.ques,"obj:",this.myobj);
    if (this.myobj.profileQuestions[0].answer != "" && this.myobj.profileQuestions[1].answer != "" && this.myobj.profileQuestions[2].answer != "" && this.myobj.profileQuestions[3].answer != "") {
      //////console.log("in");
      // let profile ={
      //   "profileQuestions":this.myobj,
      //   "PatientId":this.params.patid
      // }
      this.myobj.userAccountId = this.CurrentUser.item.userAccountId;
      //////console.log(this.myobj)
      this.patientservice.savequestion(this.myobj)
        .subscribe(
          data => {
            //////console.log(data);
            if (data.updateStatus == "true") {


              this.routers.navigate([`/patient/dashboard`])
              this.myobj.profileQuestions.answer = ""
            } else {
              this.resabs = this.userservice.translateText('hospital_portal.disp_messages.enter_valid_data.errormsg');

            }

          }
        );

    } else {
      this.resabs = this.userservice.translateText('patient_portal.validations.enter_all_fields.error_label');
      //////console.log("Out");
    }
  }
  login() {
    this.routers.navigate([`/patient/dashboard`])
  }
  goback() {
    this.patientid = window.localStorage['Puser'];
    this.routers.navigate([`/patient/dashboard`])
    /*  this.userservice
     .goback(this.patientid,'isSupportDone')
     .subscribe(
       data => {
         if(data){
           this.routers.navigate([`/patient/dashboard`])
           
         }
       }
     ); */
  }
}
